<template>
  <div class="md-layout text-center">
    <div
      class="md-layout-item md-size-33 md-medium-size-50 md-small-size-70 md-xsmall-size-100"
    >
      <login-card header-color="blue">
        <h4 slot="title" class="title text-left">Log in</h4>
        <md-field class="md-form-group" slot="inputs">
          <md-icon>email</md-icon>
          <label>Email...</label>
          <md-input v-model="email" type="email"></md-input>
        </md-field>
        <md-field class="md-form-group" slot="inputs">
          <md-icon>lock_outline</md-icon>
          <label>Password...</label>
          <md-input v-model="password" type="password"></md-input>
        </md-field>
        <router-link slot="inputs" :to="{ name: 'Forgot Password' }"
          >Forgot your Password ...</router-link
        >
        <md-button
          type="submit"
          slot="footer"
          class="md-simple md-primary md-lg"
          @click.prevent="login"
        >
          Lets Go
        </md-button>
      </login-card>
    </div>
  </div>
</template>
<script>
import { LoginCard } from "@/components";
import { AuthRequest } from "@/store/actions/auth";

export default {
  components: {
    LoginCard
  },
  data() {
    return {
      email: null,
      password: null,
      error: false
    };
  },
  methods: {
    login: function() {
      const { email, password } = this;
      this.$store
        .dispatch(AuthRequest, { email, password })
        .then(resp => {
          this.$router.push("Dashboard");
        })
        .catch(err => {
          this.$notify({
            timeout: 2500,
            message: err.response.data.message,
            icon: "error",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "danger"
          });
        });
    }
  }
};
</script>

<style></style>
